<template>
  <div class="dashboard">
    <component-navbar />
    <div class="jumbotron">
      <div class="container">
        <h1 class="display-4">
          {{ $t("secure.phrases.headline") }} <b-badge>{{ this.$store.state.phrases | count }}</b-badge>
        </h1>
        <p class="lead">
          {{ $t("secure.phrases.lead_in") }}
        </p>
        <b-row class="mb-2">
          <b-col cols="12">
            <b-input-group size="md" prepend="FILTER" :append="_.size(phrasesOut) +' / '+ _.size(this.$store.state.phrases)">
              <b-form-input id="filterPhrase" v-model="filterPhrase" name="filterPhrase" :placeholder="$t('general.suchen_nach')" />
            </b-input-group>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="9">
            TAGS
          </b-col>
          <b-col cols="3">
            SORTIERUNG
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-list-group>
              <b-list-group-item v-for="(item,i) in phrasesOut" :key="i" class="flex-column align-items-start">
                <b-row>
                  <b-col cols="12" md="9">
                    <h5 class="mb-1">
                      {{ item.name }}
                    </h5>
                    <small v-if="item.description">
                      {{ item.description }}
                    </small>
                    <p class="mb-1">
                      {{ item.content }}
                    </p>
                  </b-col>
                  <b-col cols="6" md="3" class="text-right">
                    <small>
                      {{ item.last_modified | moment("utc") | moment('timezone', 'Europe/Berlin', "L LTS") }} Uhr
                    </small><br>
                    <small>2{{ $t("secure.phrases.in_verwendung") }}</small>
                    <b-link @click="duplicatePhrase(item.id)">
                      <font-awesome-icon icon="clone" fixed-width /> {{ $t('general.duplizieren') }}
                    </b-link>
                    <b-link @click="deletePhrase(item.id)">
                      <font-awesome-icon icon="times" fixed-width /> {{ $t('general.loeschen') }}
                    </b-link>
                    <b-link @click="openSecureModal( 'modalEditPhrase', item.id)">
                      <font-awesome-icon icon="edit" fixed-width /> {{ $t('general.bearbeiten') }}
                    </b-link>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
        <a href="javascript:void(null);" class="btn btn-info" @click="addPhrase()"><font-awesome-icon icon="plus" fixed-width /> {{ $t("secure.phrases.neue_phrase") }}</a>
      </div>
    </div>
  </div>
</template>

<script>

import componentNavbar from '@/components/Navbar'
import componentFormPhrase from '@/components/forms/Phrase'

export default {
  components: {
    componentNavbar
  },
  data () {
    return {
      filterPhrase: '',
      filterPhraseCount: 0,
      sortBy: 'title_az',
      sortByName: 'Title A-Z',
    }
  },
  computed: {
    phrasesOut: function() {
      var list = this.$store.state.phrases
      var filterPhrase = this.filterPhrase
      var filtered = []
      if (filterPhrase.trim().length > 0) {
        var regEx = new RegExp(`(.*)${filterPhrase.toLowerCase().trim()}(.*)`)
        this._.map(list, function (o) {
          if (o.name.toLowerCase().match(regEx)) {
            filtered.push(o)
          }
        })
        list = filtered
      }
			return list;
    }
  },
  mounted() {
    this.$auth.renewSession()
  },
  methods: {
    resetFilterPhrase () {
      this.filterPhrase = ''
      this.filterPhraseCount = (typeof this.$store.state.phrases !== 'undefined' ? this.$store.state.phrases.length : 0)
    },
  }
}
</script>
